
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Slide from '@/interfaces/models/Slide';

const cart = namespace('cart');

@Component({
  components: {}
})
export default class AssetCardSelectionBoundary extends Vue {
  private selected: boolean = false;
  @Prop({ type: String }) assetId!: string;

  @cart.State(x => x.selection) selectionItems!: string[];

  @Watch('selectionItems', { deep: true, immediate: true })
  onCartChange(selectionItems: string[]) {
    this.selected = !!selectionItems.includes(this.assetId);
  }

  render() {
    return this.$scopedSlots.default!({
      selected: this.selected
    });
  }
}
